import type { ExportAppearanceOptions } from '@mss_creator/shared';
import { ExportSegmentedControl } from './export-segmented-control';
import type { SegmentOption } from './export-segmented-control';
import { ExportSelectField } from './export-select-field';
import { ExportToggleField } from './export-toggle-field';

interface ExportAppearanceControlsProps {
  appearance: ExportAppearanceOptions;
  onChange: (appearance: ExportAppearanceOptions) => void;
}

const THEME_OPTIONS: readonly SegmentOption<ExportAppearanceOptions['headerTheme']>[] = [
  { value: 'white', label: 'Blanc' },
  { value: 'pitch', label: 'Palette' },
  { value: 'noyau-gradient', label: 'Dégradé noyau' },
];

const BORDER_OPTIONS: readonly SegmentOption<ExportAppearanceOptions['borders']>[] = [
  { value: 'fines', label: 'Fines' },
  { value: 'marquees', label: 'Marquées' },
];

/** The « Apparence » category: header theme, borders and zebra striping. */
export function ExportAppearanceControls({ appearance, onChange }: ExportAppearanceControlsProps) {
  return (
    <>
      <ExportSelectField
        label="Thème"
        value={appearance.headerTheme}
        options={THEME_OPTIONS}
        onChange={(headerTheme) => onChange({ ...appearance, headerTheme })}
      />
      <ExportSegmentedControl
        label="Bordures"
        value={appearance.borders}
        options={BORDER_OPTIONS}
        onChange={(borders) => onChange({ ...appearance, borders })}
      />
      <ExportToggleField
        label="Zébrage"
        checked={appearance.zebra}
        onChange={(zebra) => onChange({ ...appearance, zebra })}
      />
    </>
  );
}
